var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiObjectives = function SvgAiObjectives(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 4,
    clipPath: "url(#ai-objectives_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "url(#ai-objectives_svg__b)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2 32V2h36v18.462"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ACB5C2",
    d: "M28 14a4 4 0 1 1 0 8 4 4 0 0 1 0-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ACB5C2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M38 38c0-5.523-4.477-10-10-10s-10 4.477-10 10l-6-12"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#ai-objectives_svg__c)",
    strokeLinecap: "round",
    d: "M10 10h8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#ai-objectives_svg__d)",
    strokeLinecap: "round",
    d: "M10 16h4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai-objectives_svg__b",
    x1: 2,
    x2: 33.84,
    y1: 32,
    y2: -1.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60F3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#00CCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009AC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai-objectives_svg__c",
    x1: 8,
    x2: 8.198,
    y1: 13,
    y2: 10.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60F3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#00CCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009AC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai-objectives_svg__d",
    x1: 8,
    x2: 8.294,
    y1: 19,
    y2: 16.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60F3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#00CCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009AC0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ai-objectives_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
};
export { SvgAiObjectives as ReactComponent };
export default __webpack_public_path__ + "fonts/ai-objectives-63bc139d531958ae7d6ff647f9f73c1e.svg";